import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = {
  class: "block uppercase tracking-wide text-darkGray-1 text-xs font-bold mb-1",
  for: "name"
}
const _hoisted_3 = { class: "relative w-full" }
const _hoisted_4 = ["id", "value", "placeholder", "disabled"]

import { ref, watch, onMounted, PropType } from "vue";

const ON_CHANGED = "onChanged";

export default /*@__PURE__*/_defineComponent({
  __name: 'InputText',
  props: {
  value: {
    type: String || Number,
    required: true,
  },
  id: String,
  label: String,
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  placeholder: String, 
  validator: Function as PropType<(value: string) => boolean | undefined>, // Corrected validator prop type

},
  setup(__props, { emit: __emit }) {

const props = __props;
const value = ref(props.value);

const emit = __emit;
onMounted(() => {
  value.value = props.value;
});

// ANSKNI-181: reflect parent updates that arrive after mount (e.g. ANSKNI-176
// auto-fills address/zip asynchronously once the builder data has loaded).
// Without this watch the field keeps the initial snapshot and shows blank.
watch(
  () => props.value,
  (v) => {
    if (v !== value.value) {
      value.value = v;
    }
  }
);
function customChange(v: any) {
  let inputValue = (v.target as HTMLInputElement).value;
  if (props.validator) {
    if (!props.validator(inputValue)) {
      (v.target as HTMLInputElement).value = value.value as string; // Reset to previous value
      return;
    }
  }
    value.value = v.target.value;
    emit(ON_CHANGED, value.value);
  

}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, _toDisplayString(props.label), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("input", {
        onInput: customChange,
        class: "appearance-none block w-full bg-white text-darkGray-1 placeholder-darkGray-4 border border-blue-4 rounded py-1 sm:py-3 px-4 leading-tight focus:bg-white focus:border-blue-1 disabled:bg-gray-2 disabled:text-darkGray-2 disabled:cursor-not-allowed relative",
        id: props.id,
        type: "text",
        value: value.value,
        placeholder: props.placeholder,
        disabled: props.disabled
      }, null, 40, _hoisted_4)
    ])
  ]))
}
}

})